import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';
import bwipjs from 'bwip-js';  

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName='', 
            variableUnavailable=false, 
        } = executionObject;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        let variableCopy = parsedParameters['variableObject'];
        if(parsedParameters.error){
            variableCopy[variableName] = {
                error : {
                    message : 'Failed to parse function parameters.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];
        let options = {
            bcid : resolvedParams['barcodeType'] || '',
            text : resolvedParams['text'] || '',
            alttext : resolvedParams['altText'] || '',
            includetext : resolvedParams['includeText']
        };
        if(resolvedParams['scale']){
            options['scale'] = resolvedParams['scale'];
        }
        if(resolvedParams['textAlign']){
            options['textalign'] = resolvedParams['textAlign'];
        }
        if(resolvedParams['height']){
            options['height'] = resolvedParams['height'];
        }
        if(resolvedParams['width']){
            options['width'] = resolvedParams['width'];
        }
        if(resolvedParams['rotate']){
            options['rotate'] = resolvedParams['rotate'];
        }
        if(resolvedParams['barColor']){
            options['barcolor'] = resolvedParams['barColor'];
        }
        if(resolvedParams['textColor']){
            options['textcolor'] = resolvedParams['textColor'];
        }
        if(resolvedParams['backgroundColor']){
            options['backgroundcolor'] = resolvedParams['backgroundColor'];
        }
        if(resolvedParams['padding']){
            options['padding'] = resolvedParams['padding'];
        }

        if(!options['bcid']){
            variableCopy[variableName] = {
                error : {
                    message : 'Barcode type is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Barcode type is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(!options['text']){
            variableCopy[variableName] = {
                error : {
                    message : 'Text is required.'
                }
            }
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Text is required.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let canvas = document.createElement('canvas');
        let barcode = bwipjs.toCanvas(canvas, options);
        variableCopy[variableName] = barcode.toDataURL('image/png');
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : false,
            errorPayload : undefined
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/generateBarcodeParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}